export default __webpack_public_path__ + "static/media/fabio-mangione.3485912d.jpg";